import { FormFieldDataType } from '../../../common/src/lib/kronos-data';

export const commonEnv = {
  agGridLicenseKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-131507}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{GLB_Genossenschaft}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Flow}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Flow}_need_to_be_licensed___{Flow}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{3_June_2027}____[v3]_[01]_MTgxMTk3NzIwMDAwMA==15facca132adbdd495f644ec297528ea',
  newCustomerId: '554007',
  infoDashboard: {
    title: 'Wissenszentrale für gemeinsamen Erfolg.',
  },
  transcribe: {
    enabled: true,
    translateTargetLanguage: 'de',
    languages: [
      {
        locale: 'de-CH',
        label: 'Deutsch',
      },
      {
        locale: 'es-ES',
        label: 'Spanisch',
      },
      {
        locale: 'pt-PT',
        label: 'Portugiesisch',
      },
      {
        locale: 'sq-AL',
        label: 'Albanisch',
      },
      {
        locale: 'hr-HR',
        label: 'Kroatisch',
      },
      {
        locale: 'sr-RS',
        label: 'Serbisch ',
      },
      {
        locale: 'ar-SA',
        label: 'Arabisch',
      },
      {
        locale: 'ro-RO',
        label: 'Rumänisch',
      },
      {
        locale: 'uk-UA',
        label: 'Ukrainisch',
      },
    ],
  },
  formValidators: [
    {
      name: 'Email',
      regex: '^.+@.+\\..+$',
    },
    {
      name: 'Telefon',
      regex:
        '^(\\+\\s?\\d)?\\d\\s?\\d\\s?\\d\\s?\\d\\s?\\d\\s?\\d\\s?\\d\\s?\\d\\s?\\d\\s?\\d$',
    },
    {
      name: 'AHV Nummer',
      regex: '^[\\d]{3}\\.[\\d]{4}\\.[\\d]{4}\\.[\\d]{2}$',
    },
    {
      name: 'Datum',
      regex:
        '^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[13-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$',
    },
  ],
  autoCompleteOptions: [
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Name',
      value: 'name',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Vorname',
      value: 'given-name',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Nachname',
      value: 'family-name',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Anrede',
      value: 'honorific-prefix',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Namenszusatz',
      value: 'honorific-suffix',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Geschlecht',
      value: 'sex',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Geburtstag',
      value: 'bday',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Sprache',
      value: 'language',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Email',
      value: 'email',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Telefon',
      value: 'tel',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Webseite',
      value: 'url',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Benutzername',
      value: 'username',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Firma',
      value: 'organization',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Adresse',
      value: 'street-address',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'PLZ',
      value: 'postal-code',
    },
    {
      fieldTypes: [FormFieldDataType.Text],
      name: 'Land',
      value: 'country',
    },
  ],
  chatFileUploadWhiteList:
    'image/jpeg, image/gif, image/heic, image/heif, image/png, application/pdf, video/mp4, video/quicktime',
  chatFileUploadWhiteListMessage:
    '.jpeg, .jpg, .png, .gif, .pdf, .mp4, .mov, .heic, .heif',
};
